export const INITIAL_CODE_VAL_LIST = [
  "ESV_INVOICE_LEVEL",
  "ESV - Services",
  "Manage Invoice Tags/Categories",
  "ESV_INVOICE_SORT",
];
